import { getGlobalClientId, getToken } from "../../../../utils/Token";
import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import { getOrgType } from "../../../../utils/Token";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Tooltip,
  Button,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import useFetch from "../../../../utils/useFetch";
import BaseURL from "../../../../utils/base-uri.json";

export default function ReportInjuryStatistics({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(getToken())

  useEffect(() => {
    axios
    .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
    getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res?.data?.data);
          if(getOrgType()=="Client"){
            setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [getTemplate, SetTemplate] = React.useState([]);
  const changeClients = (e) => {
    setSelectValue1(e);
  };
  const { data: res } = useFetch(
    "Companies/GetTemplateDetails?organizationId=" + selectValue1
  );
  useEffect(() => {
    if (res?.data) {
      SetTemplate(res?.data);
    }
  }, [res]);

  const data = getTemplate[0];
  const [selectedValue, setSelectedValue] = useState(data);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>


        <form
          action={
            BaseURL?.baseReportUrl+"InjuryStatisticsReport.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register("client")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                name="ClientId"
                size="small"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Client"

                    value={selectValue1}
                  />
                }
                MenuProps={MenuProps}
              >
                {client.map((item, index) => (
                  <MenuItem key={index} value={item.value} title={item.text}sx={{ overflowX:"hidden",textOverflow:"ellipsis"}}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client Template
              </span>
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
                value={selectedValue}
                name="TemplateId"
                onChange={handleChange}
              >
                {getTemplate?.map((option) => (
                  <MenuItem key={option.value} value={option.value}  title={option.text} sx={{ overflowX:"hidden",textOverflow:"ellipsis"}}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>
              {selectedValue == undefined || selectValue1 == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={selectedValue == undefined || selectValue1 == ""}
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

        <br />
      </DialogContent>
    </>
  );
}
